module.exports = __webpack_public_path__ + "img/logo_app.d722f272.svg";